export const hexToHexA = (hex, opacity = 1) => {
  const rgba = hexToRgbA(hex);
  const color = (Color, alpha = opacity, Background = 255) => Math.ceil(Color * alpha + Background * (1 - alpha));
  return RGBToHex(color(rgba.r), color(rgba.g), color(rgba.b));
};

const hexToRgbA = hex => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : {
        r: 255,
        g: 255,
        b: 255,
      };
};

const RGBToHex = (red, green, blue) => {
  let r = red.toString(16);
  let g = green.toString(16);
  let b = blue.toString(16);

  if (r.length === 1) r = "0" + r;
  if (g.length === 1) g = "0" + g;
  if (b.length === 1) b = "0" + b;

  return "#" + r + g + b;
};

export const hexToRgbWithOpacity = (hex, alpha = 1) => {
  let c;
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split("");
    if (c.length == 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }
    c = "0x" + c.join("");
    return `rgba(${[(c >> 16) & 255, (c >> 8) & 255, c & 255].join(",")}, ${alpha})`;
  }
  throw new Error("Bad Hex");
};
